import PropTypes from 'prop-types';
import { buildPickupLocation } from '../../utils/classifiedUtil';

const PickupBox = ({ classified }) => {
  const pickup = buildPickupLocation(classified);

  return <section className="pickup">
    <h3>{pickup.name}</h3>
    {pickup.detail}
  </section>;
};

PickupBox.propTypes = {
  classified: PropTypes.shape({
    pickupAt: PropTypes.oneOf(['school', 'sale_point']).isRequired,
    school: PropTypes.shape({
      shortname: PropTypes.string.isRequired,
      department: PropTypes.string,
    }),
    sale_point: PropTypes.shape({
      sale_point: PropTypes.string.isRequired,
      zip_code: PropTypes.shape({
        city: PropTypes.string.isRequired,
      }).isRequired,
    }),
  }).isRequired,
};

export default PickupBox;
